exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".can-not-input[data-v-f3e16646] input{pointer-events:none}", ""]);

// exports
